const themes = [
  {
    name: 'light',
    colors: {
      primaryColor: '#ff785a',
      secondaryColor: '#9bc53d',
      textColor: '#1e314f',
      background: '#ffffff',
      backgroundHover: '#f3f3f3',
      inverseBackground: '#1e314f',
    },
  },
  {
    name: 'dark',
    colors: {
      primaryColor: '#ff785a',
      secondaryColor: '#9bc53d',
      textColor: '#f1f1f1',
      background: '#1e314f',
      backgroundHover: '#18273f',
      inverseBackground: '#f1f1f1',
    },
  },
];

export default themes;
